import {useMutation} from "@tanstack/react-query";

import {removeServiceFunctionMutationOptions} from "./remove-service-function.mutation-options";

export function useRemoveServiceFunction(id: string) {
  return useMutation(removeServiceFunctionMutationOptions(id));
}
